var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0005 8.96259L1.00049 4.96259L11.0005 0.962585L21.0005 4.96259L11.0005 8.96259Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27903 14.2661C0.894444 14.1123 0.457966 14.2993 0.304131 14.6839C0.150296 15.0685 0.337358 15.505 0.721945 15.6588L1.27903 14.2661ZM11.0005 18.9625L10.7219 19.6588C10.9008 19.7303 11.1002 19.7303 11.279 19.6588L11.0005 18.9625ZM21.279 15.6588C21.6636 15.505 21.8507 15.0685 21.6968 14.6839C21.543 14.2993 21.1065 14.1123 20.7219 14.2661L21.279 15.6588ZM1.27903 9.26623C0.894444 9.11239 0.457966 9.29945 0.304131 9.68404C0.150296 10.0686 0.337358 10.5051 0.721945 10.6589L1.27903 9.26623ZM11.0005 13.9626L10.7219 14.6589C10.9008 14.7305 11.1002 14.7305 11.279 14.6589L11.0005 13.9626ZM21.279 10.6589C21.6636 10.5051 21.8507 10.0686 21.6968 9.68404C21.543 9.29945 21.1065 9.11239 20.7219 9.26623L21.279 10.6589ZM0.721945 15.6588L10.7219 19.6588L11.279 18.2661L1.27903 14.2661L0.721945 15.6588ZM11.279 19.6588L21.279 15.6588L20.7219 14.2661L10.7219 18.2661L11.279 19.6588ZM0.721945 10.6589L10.7219 14.6589L11.279 13.2662L1.27903 9.26623L0.721945 10.6589ZM11.279 14.6589L21.279 10.6589L20.7219 9.26623L10.7219 13.2662L11.279 14.6589Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/research.11b619711c863d46d33681bfbb73c092.svg";